import {Component, OnInit, Input, OnDestroy} from '@angular/core';
import {CustomerService} from '../../../customer/data/customer.service';
import {MatDialog} from '@angular/material/dialog';
import {CustomerWindowComponent} from '../../../customer/view/customer-window/customer-window.component';
import {Project} from '../../data/project/project';
import {ProjectService} from '../../data/project/project.service';
import {Customer} from '../../../customer/data/customer';
import {ContactInfo} from '../../../customer/data/contactInfo';
import {WsUpdateResponce} from '../../../data/ws-update-responce';
import {WsService} from '../../../data/ws.service';
import {filter, takeUntil} from 'rxjs/operators';
import {Subject, Subscription} from 'rxjs';
import {RxJSUnsubscribable} from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';
import {RxJSUnsubscribe} from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';

class DropDownChoise<T> {
  item: T;
  type: 'item' | 'create-new';

}

@Component({
  selector: 'app-customer-search',
  templateUrl: './customer-search.component.html',
  styleUrls: ['./customer-search.component.scss']
})
@RxJSUnsubscribe
export class CustomerSearchComponent implements OnInit, OnDestroy, RxJSUnsubscribable {

  @Input()
  projectId: number;

  @Input()
  nfsContacts: ContactInfo[];

  @Input()
  customer: Customer;

  currentChoise: DropDownChoise<Customer>;

  dropDownItems: DropDownChoise<Customer>[];

  searchQuery: string;

  wsSub: Subscription;

  constructor(
    protected projectService: ProjectService,
    protected customerService: CustomerService,
    private dialog: MatDialog,
    protected wsService: WsService
  ) {
  }

  ngOnInit() {
    this.currentChoise = {
      item: this.customer,
      type: 'item'
    } as DropDownChoise<Customer>


    this.wsSub = this.wsService
      .listenUntilDestroyed<WsUpdateResponce<Project>>('/topic/update/model.project.Project', this)
      .pipe(
        filter(updateInfo => typeof updateInfo.entity.customer !== 'undefined' && updateInfo.entity.id === this.projectId)
      )
      .subscribe(updateInfo => {
        if (updateInfo.action === 'UPDATE') {
          if (updateInfo.entity.customer) {
            this.customerService.getCustomer(updateInfo.entity.customer.id).subscribe(customer => {
              this.currentChoise = {
                item: customer,
                type: 'item'
              } as DropDownChoise<Customer>
            })
          }
        }
      })
  }


  openClientWindow() {
    const dialogRef = this.dialog.open(CustomerWindowComponent, {
      data: {
        id: this.customer.id,
        name: this.currentChoise.item.name,
        projectId: this.projectId,
        nfsContacts: this.nfsContacts
      },
      panelClass: 'customer-window-dialog'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'DELETE') {

      } else {
        this.customerService.getCustomer(this.customer.id).subscribe(customer => {
          this.customer = customer;

          this.currentChoise = {
            item: customer,
            type: 'item'
          } as DropDownChoise<Customer>
        })
      }
    });
  }

  filterCountrySingle(event) {
    this.searchQuery = event.query

    this.customerService
      .searchActiveCustomers(this.searchQuery, 0, 25)
      .subscribe(customers => {
        this.dropDownItems = customers.content.map(customer => {
          return {
            item: customer,
            type: 'item'
          } as DropDownChoise<Customer>
        })
        this.dropDownItems.push({
          item: null,
          type: 'create-new'
        })

      })
  }

  newCustomer(event) {

    this.customerService.createCustomerWithName(this.searchQuery).subscribe(newCustomer => {

      if (!newCustomer.billingInfoContact) {
        newCustomer.billingInfoContact = new ContactInfo();
      }

      if (!newCustomer.contacts) {
        newCustomer.contacts = [];
      }

      const dialogRef = this.dialog.open(CustomerWindowComponent, {
        data: {
          id: newCustomer.id,
          name: newCustomer.name
        },
        panelClass: 'customer-window-dialog'
      });

      dialogRef.afterClosed().subscribe(result => {
        this.customerService.getCustomer(newCustomer.id).subscribe(customer => {
          this.customer = customer

          this.currentChoise = {
            item: customer,
            type: 'item'
          } as DropDownChoise<Customer>

          this.updateCustomer(this.currentChoise);
        })
      });

    })
  }

  updateCustomer(choise: DropDownChoise<Customer>) {
    this.customer = choise.item;

    this.projectService
      .saveProject({
        id: this.projectId,
        customer: choise.item
      })
      .subscribe(project => {
        this.customerService.nfsContacts.next({
          allContacts: [],
          selectedContacts: []
        })
      })
  }

  deleteCustomer(event) {
    // this.projectService.detachCustomer(this.project.id).subscribe(project => {
    // 	this.project.customer.billingInfoContact.phone1 = '';
    // 	this.project.customer.billingInfoContact.email = ''
    // })
    console.log('DELETED')
  }

  ngOnDestroy() {
    if (this.wsSub) {
      this.wsSub.unsubscribe()
      this.wsSub = null;
    }
  }

  getUnsubFromAllSubs(): Subject<boolean> {
    return null
  }

}
